/**
 * MenuItemTextContainer component.
 */
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled container for the menu item text.
 */
const MenuItemTextContainer = styled.div`
  display: inline-block;
  font-family: ${Fonts['regular']};
  max-width: ${268 * Screen.widthRatio}px;
  padding-left: ${4 * Screen.widthRatio}px;
  padding-right: ${4 * Screen.widthRatio}px;
  overflow: hidden;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.8);
  white-space: nowrap;
`;

export default withOpacity(MenuItemTextContainer);
